import React from 'react';

const PriceToggle = ({ ranges, selectedRange, onChange, darkMode }) => {
    return (
        <div className="flex flex-wrap" role="radiogroup" aria-label="Ценовой диапазон">
            {ranges.map(range => (
                <button
                    key={range.label}
                    onClick={() => onChange(range.value)}
                    className={`px-4 py-2 rounded-full text-sm mr-2 mb-2 ${selectedRange &&
                        ((selectedRange.min === range.value.min && selectedRange.max === range.value.max) ||
                            (selectedRange.min === range.value.min && !selectedRange.max && !range.value.max) ||
                            (!selectedRange.min && !range.value.min && selectedRange.max === range.value.max))
                        ? (darkMode ? 'bg-blue-700 text-white' : 'bg-blue-500 text-white')
                        : (darkMode ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-800')
                        }`}
                    role="radio"
                    aria-checked={selectedRange &&
                        ((selectedRange.min === range.value.min && selectedRange.max === range.value.max) ||
                            (selectedRange.min === range.value.min && !selectedRange.max && !range.value.max) ||
                            (!selectedRange.min && !range.value.min && selectedRange.max === range.value.max))}
                >
                    {range.label}
                </button>
            ))}
        </div>
    );
};

export default PriceToggle;